<template>
  <span v-html="html"></span>
</template>

<script>
export default {
  name: 'LinkableText',

  props: {
    value: {
      type: String,
      default: '',
    },
  },

  computed: {
    html() {
      return !this.value
        ? ''
        : this.value.replace(
            /(https?)(:\/\/[-_.!~*\\'()a-zA-Z0-9;\\/?:\\@&=+\\$,%#]+)/g,
            '<a href="$1$2" target="_blank">$1$2</a>'
          );
    },
  },
};
</script>

<style scoped></style>
